export const CREATE_FILE = "CREATE_FILE";
export const DELETE_FILE = "DELETE_FILE";
export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
